<template>
  <div class="col-md-12 mb-4">
          <!-- Breadcrumbs -->
    <div style="padding: 10px; background-color: #F2F2F2; margin-bottom: 20px;">
      <router-link to="/dashboard">Dashboard</router-link>
      /
      <b>{{ lps() }}</b>
      /
      <router-link to="/lps/affiliate">Affiliates</router-link>
      /
      <b>Affiliate Details</b>
    </div>
    <div class="card text-left"   style="margin-bottom: 30px;">
      <div class="card-body">
        <affiliate-edit></affiliate-edit>
      </div>
    </div>
    <div class="card text-left">

      <div class="card-body">
        <affiliate-referral-code></affiliate-referral-code>
      </div>
    </div>
  </div>
</template>

<script>
import AffiliateReferralCode from "@/views/contents/loyalty/ReferralCode/Referral/Index";
import AffiliateEdit from "@/views/contents/loyalty/ReferralCode/Affiliate/Edit";
export default {
  components: {
    AffiliateReferralCode, AffiliateEdit
  },

  methods: {
    lps() {
      return this.$lps();
    }
  },
};
</script>
      